import { render, staticRenderFns } from "./RoomMeetingSettings.vue?vue&type=template&id=1cf0d11e&scoped=true&"
import script from "./RoomMeetingSettings.vue?vue&type=script&lang=ts&"
export * from "./RoomMeetingSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RoomMeetingSettings.vue?vue&type=style&index=0&id=1cf0d11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf0d11e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf0d11e')) {
      api.createRecord('1cf0d11e', component.options)
    } else {
      api.reload('1cf0d11e', component.options)
    }
    module.hot.accept("./RoomMeetingSettings.vue?vue&type=template&id=1cf0d11e&scoped=true&", function () {
      api.rerender('1cf0d11e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/rooms/room/RoomMeetingSettings.vue"
export default component.exports